<template>
  <v-dialog :value="show" persistent max-width="500">
    <v-card>
      <v-card-title>
        <span class="title-modal">
          Atenção
        </span>
      </v-card-title>
      <v-card-text>
        <template v-if="!hasBalance">
          Atenção: Esta operação é irreversível. Tem certeza de que deseja excluir definitivamente esta conta?
        </template>
        <template v-else-if="allowsRefund">
          Atenção: Esta conta possui um saldo de R${{ formatMoney(balance) }}. Você pode excluir sua conta (e perder
          este saldo) ou solicitar o reembolso do valor. O que deseja fazer?
        </template>
        <template v-else>
          Atenção: Esta conta possui um saldo de R${{ formatMoney(balance) }}. Ao excluí-la, o saldo será perdido.
          Deseja realmente confirmar a exclusão da conta?
        </template>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1 text-right">
          <v-btn
              class="btn-custom btn-back mr-2"
              @click.prevent="$emit('cancel')"
              text
          >
            Voltar
          </v-btn>
          <template v-if="hasBalance && allowsRefund">
            <v-btn
                class="btn-custom btn-refund mr-2"
                @click.prevent="$emit('refund')"
                text
            >
              Reembolso
            </v-btn>
            <v-btn
                class="btn-custom btn-delete"
                @click.prevent="$emit('delete', true)"
                text
            >
              Excluir
            </v-btn>
          </template>
          <template v-else>
            <v-btn
                class="btn-custom btn-delete"
                @click.prevent="$emit('delete', hasBalance)"
                text
            >
              Excluir
            </v-btn>
          </template>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteAccountDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    balance: {
      type: Number,
      default: 0
    },
    allowsRefund: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasBalance() {
      return this.balance > 0;
    }
  },
}
</script>

<style scoped>
.title-modal {
  word-break: normal;
  text-align: center;
  margin: auto;
}

@media only screen and (max-width: 500px) {
  .v-card__actions button {
    width: 100%;
    margin: 5px 0 !important;
  }
}

.btn-custom {
  text-transform: capitalize !important;
  color: #ffffff !important;
  font-family: Roboto-Black !important;
  width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #000 !important;
}

.btn-back {
  background: #003A73 !important;
}

.btn-delete {
  background: #e72c1f !important;
}

.btn-refund {
  background: #28a745 !important;
}

.btn-custom:hover {
  background: transparent !important;
  color: #000 !important;
}
</style>
